import types from './types';

export const initialState = () => ({
    data: {
        cardNumber: '',
        apiError: false,
        showValidationError: false,
        pinCode: '',
        selectedCard: '',
        swipeToBuyDefaultError: '',
        swipeToBuyValidationErrorType: '',
        swipeOrderConfirmationCode: '',
    },
});

const reducers = (state = initialState(), action) => {
    switch (action.type) {
        case types.SET_DATA_ATTR:
            return {
                ...state,
                data: { ...state.data, [action.payload.name]: action.payload.value },
            };
        case types.SET_SAVED_CARD:
            return {
                ...state,
                saveCards: action.payload,
            };
        case types.SET_SELECTED_CARD:
            return {
                ...state,
                selectedCard: action.payload.cardId,
            };
        case types.SHOW_SWIPE_TO_BUY_ERROR:
            return {
                ...state,
                swipeToBuyDefaultError: action.payload,
            };
            case types.SET_LOYALTY_POINT_BALANCE:
                return {
                    ...state,
                    data: { ...state.data, 
                    pointBalance: action.payload.pointsBalance,
                    }
                }; 
            
                case types.SET_LOYALTY_EMPLOYEE_POINT_BALANCE:
                    return {
                        ...state,
                        data: { ...state.data, 
                        employeePointBalance: action.payload.pointsBalanceAmount,
                        }
                    };     
                                      
        case types.SET_SAVED_CARD_LOADED:
            return {
                ...state,
                cardLoaded: action.payload,
            };
        case types.SET_SWIPE_TO_VALIDATION:
            return {
                ...state,
                data: { ...state.data, swipeToBuyValidationErrorType: action.payload || '' },
            };
        case types.SET_SWIPE_TO_BUY_ORDER_CONFIRMATION_CODE:
            return {
                ...state,
                data: { ...state.data, swipeOrderConfirmationCode: action.payload || '' },
            };
        case types.SET_SWIPE_TO_BUY_ERROR:
            return {
                ...state,
                data: {
                    ...state.data,
                    showSwipeToBuyError: !!action.payload,
                    swipeToBuyErrorType: action.payload,
                },
            };
        default:
            return state;
    }
};

export default reducers;
